<div class="nav-container">
  <nav class="navbar">

    <div class="navbar-brand logo" routerLink="">
      <img src="assets/logo.png" />
    </div>

    <ul class="navbar-nav">
      <!-- Login button: show if NOT authenticated -->
      <li
        class="nav-item"
        *ngIf="(auth.isAuthenticated$ | async) === false"
      >
        <button
          class="primary-btn"
          mat-raised-button
          (click)="loginWithRedirect()"
        >
          Log in
        </button>
      </li>
      <!-- / Login button -->

      <li
        class="nav-item nav-user-profile"
        *ngIf="auth.user$ | async as user"
        routerLink="profile">
        <!-- Profile image should be set to the profile picture from the id token -->
        <img
          [src]="user.picture"
          alt="Profile picture"
          class="user-img rounded-circle"
        />
        <div class="user-name">
          {{ user.name }}
        </div>
      </li>

      <li class="nav-item" *ngIf="auth.isAuthenticated$ | async">
        <button
          class="danger-btn"
          mat-raised-button
          (click)="logout()"
        >
          Log out
        </button>
      </li>
    </ul>


  </nav>
</div>
